const getOSName = (userAgent) => {
  if (/iPad/.test(userAgent)) {
    return 'ios';
  } else if (/iPhone|iPod/.test(userAgent)) {
    return 'ios';
  } else if (/Macintosh/.test(userAgent)) {
    return 'macos';
  } else if (/Android/.test(userAgent)) {
    return 'android';
  } else if (/Windows/.test(userAgent)) {
    return 'windows';
  } else {
    return 'unknown';
  }
};

const getBrowserName = (userAgent) => {
  if (/opr\//i.test(userAgent) || !!(typeof window === 'object' && window.opr)) {
    return 'Opera';
  } else if (/ucbrowser/i.test(userAgent)) {
    return 'UC Browser';
  } else if (/samsungbrowser/i.test(userAgent)) {
    return 'Samsung Browser';
  } else if (/edg\/|edge\//i.test(userAgent)) {
    return 'Microsoft Edge';
  } else if (/chrome|chromium|crios/i.test(userAgent)) {
    return 'Chrome';
  } else if (/firefox|fxios/i.test(userAgent)) {
    return 'Firefox';
  } else if (/safari|applewebkit/i.test(userAgent) && !userAgent.includes('Chrome')) {
    return 'Safari';
  } else if (/trident/i.test(userAgent)) {
    return 'Internet Explorer';
  } else {
    return 'Unknown browser';
  }
};
const getBrowserVersion = (userAgent) => {
  let version;
  let match;

  if (/opr\//i.test(userAgent) || !!(typeof window === 'object' && window.opr)) {
    match = userAgent.match(/opr\/(\d+)/i);
    version = match ? match[1] : 'Unknown';
  } else if (getBrowserName(userAgent) === 'Microsoft Edge') {
    match = userAgent.match(/edg\/(\d+)/i) || userAgent.match(/edge\/(\d+)/i);
    version = match ? match[1] : 'Unknown';
  } else if (getBrowserName(userAgent) === 'Chrome') {
    match = userAgent.match(/(chrome|chromium|crios)\/(\d+)/i);
    version = match ? match[2] : 'Unknown';
  } else if (getBrowserName(userAgent) === 'Firefox') {
    match = userAgent.match(/(firefox|fxios)\/(\d+)/i);
    version = match ? match[2] : 'Unknown';
  } else if (getBrowserName(userAgent) === 'Safari') {
    match = userAgent.match(/version\/(\d+)/i);
    version = match ? match[1] : 'Unknown';
  } else if (getBrowserName(userAgent) === 'Internet Explorer') {
    match = userAgent.match(/rv:(\d+)/i);
    version = match ? match[1] : 'Unknown';
  } else if (getBrowserName(userAgent) === 'UC Browser') {
    match = userAgent.match(/ucbrowser\/(\d+)/i);
    version = match ? match[1] : 'Unknown';
  } else if (getBrowserName(userAgent) === 'Samsung Browser') {
    match = userAgent.match(/samsungbrowser\/(\d+)/i);
    version = match ? match[1] : 'Unknown';
  } else {
    version = 'Unknown browser';
  }

  if (version === 'Unknown' || version === 'Unknown browser') {
    return 'Unknown';
  }
  const numericVersion = parseInt(version);
  return isNaN(numericVersion) ? 'Unknown' : numericVersion;
};
const isTablet = (userAgent) => /iPad|Android|Touch/.test(userAgent);
const isIOSDevice = (userAgent) => /iPad|iPhone|iPod/.test(userAgent);
const isEdge = (userAgent) => getBrowserName(userAgent) === 'Microsoft Edge';
const isSafari = (userAgent) => getBrowserName(userAgent) === 'Safari';
const isOldSafari = (userAgent) => {
  const version = getBrowserVersion(userAgent);
  return getBrowserName(userAgent) === 'Safari' && version !== 'Unknown' && version < 11;
};

const isFireFox = (userAgent) => /Firefox/.test(userAgent);
const isWebkit = (userAgent) => /WebKit/.test(userAgent);
const isAppleProduct = (userAgent) => /iPad|iPhone|iPod|Macintosh/.test(userAgent);
const isAppleMobileProduct = (userAgent) => /iPad|iPhone|iPod/.test(userAgent);
const isMobile = (userAgent) => /Mobile/.test(userAgent);
const isDesktop = (userAgent) =>
  getOSName(userAgent) === 'macos' ||
  getOSName(userAgent) === 'windows' ||
  getOSName(userAgent) === 'linux';
const isIE = (userAgent) => /Trident/.test(userAgent);
const isOutdatedBrowser = (userAgent) => {
  const isOldIE = getBrowserName(userAgent) === 'Internet Explorer';
  const edgeVersion = getBrowserVersion(userAgent);
  const isOldEdge =
    getBrowserName(userAgent) === 'Microsoft Edge' && edgeVersion !== 'Unknown' && edgeVersion < 45;
  const ffVersion = getBrowserVersion(userAgent);
  const isOldFireFox =
    getBrowserName(userAgent) === 'Firefox' && ffVersion !== 'Unknown' && ffVersion < 79;
  return isOldIE || isOldSafari(userAgent) || isOldEdge || isOldFireFox;
};
const isOldEdge = (userAgent) => /Edge\/[1-9]/.test(userAgent);

module.exports = {
  isTablet,
  isIOSDevice,
  isEdge,
  isSafari,
  isOldSafari,
  isFireFox,
  isWebkit,
  isAppleProduct,
  isAppleMobileProduct,
  isMobile,
  isDesktop,
  isIE,
  isOutdatedBrowser,
  isOldEdge,
  getOSName,
  getBrowserName,
  getBrowserVersion,
};
